import React from "react";
import { useHistory } from "react-router-dom";
import { Api } from "../app-controller.js";
import { useAuth } from "../components/content/auth.jsx";
import { TabContent, TabPane, Nav, NavItem, NavLink } from "reactstrap";
import classnames from "classnames";
import { Modal, ModalHeader, ModalBody } from "reactstrap";
import Swal from "sweetalert2";
import ModalSolicitudDISAANCasoEspecial from "../components/content/casos_especiales/ModalSolicitudDISAANCasoEspecial";

class Applications extends React.Component {
  constructor(props) {
    super(props);

    /**CASOS ESPECIALES */
    this.setCasosEspecialesPage = this.setCasosEspecialesPage.bind(this);
    this.handleOpenCasoEspecial = this.handleOpenCasoEspecial.bind(this);
    this.closeModalCasoEspecial = this.closeModalCasoEspecial.bind(this);
    this.handleSingleErrorForm = this.handleSingleErrorForm.bind(this);
    this.cleanErrorsValidation = this.cleanErrorsValidation.bind(this);
    this.handleCasosEspecialesPage = this.handleCasosEspecialesPage.bind(this);
    this.handleCasoEspecialEstatus = this.handleCasoEspecialEstatus.bind(this);
    this.handleImportacionAdicionalDataChange =
      this.handleImportacionAdicionalDataChange.bind(this);
    this.handleCasoEspecialDocumentoEstatusChange =
      this.handleCasoEspecialDocumentoEstatusChange.bind(this);
    /** TERMINA CASOS ESPECIALES */

    this.handlePrevia = this.handlePrevia.bind(this);

    this.state = {
      previa: false,
      previa_url: "",
      working: true,
      toggle: false,
      nivelUsuario: localStorage.nivel_actual,
      paginaActual: 0,
      paginas: 0,
      cat_estatus_tramite_ce: Api.loadCatalogue("cat_estatus_tramite"),
      cat_tipo_importacion: Api.loadCatalogue("cat_tipo_importacion"),

      activeTab: "1",
      buscar: {},

      collapse: [
        {
          id: 1,
          collapse: true,
        },
        {
          id: 2,
          collapse: false,
        },
        {
          id: 3,
          collapse: false,
        },
      ],

      /** CASOS ESPECIALES */
      paginaActual_ce: 0,
      paginas_ce: 0,
      registros_ce: 0,
      openModalCasoEspecial: false,
      casos_especiales: [],
      caso_especial: {
        id: "",
        solicitud_id: "",
        tipo_importacion_id: "",
        usuario_id: "",
        status: "",
        created: "",
        modified: "",
        casos_especiales_establecimiento_id: "",
        documentacion: [],
        datos_importacion: {},
        establecimiento: {},
        tipo_importacion: {},
        productos: [],
        todosDocsAprobados: false,
      },
      importacion: {
        importacion_texto: "",
        fines_texto: "",
      },

      solicitud_ce: {
        id: "",
        folio_solicitud: "",
        accion_id: "",
        tramite_id: "",
        estatus_tramite_id: "",
        fecha_solicitud: "",
        estatus: {},
        tramite: {},
        accion: {},
      },
      solicitud_mov: {
        id: "",
        folio_solicitud: "",
        accion_id: "",
        tramite_id: "",
        estatus_tramite_id: "",
        fecha_solicitud: "",
        estatus: {},
        tramite: {},
        accion: {},
      },
    };
    this.toggleCollapse = this.toggleCollapse.bind(this);

    if (props.auth.user.name === undefined) {
      this.props.history.push("login");
    }

    /* 	this.setState({
			collapse: newArray
		}); */
  }

  toggleTab(tab) {
    if (this.state.activeTab !== tab) {
      this.setState({ activeTab: tab });
    }
  }

  toggleCollapse(index) {
    var newArray = [];
    for (let collapseObj of this.state.collapse) {
      if (collapseObj.id === index) {
        collapseObj.collapse = !collapseObj.collapse;
      } else {
        collapseObj.collapse = false;
      }
      newArray.push(collapseObj);
    }

    this.setState({ collapse: newArray });
  }

  componentDidMount() {
    // si el usuario no es nivel disaan redireccionamos a home
    if (this.state.nivelUsuario !== "8") {
      window.location.href = "/";
    }

    this.setState({ buscar: this.search });

    this.setCasosEspecialesPage(1);

    /* BUSCADORES */
    /** BUSCADOR PARA CASOS ESPECIALES */
    let buscadorCE = {
      target: "#buscadorCE",
      nombre: "buscadorCE",
      elementClass: "form-control",
      elements: [
        {
          input: {
            cols: 3,
            name: "folio_solicitud",
            type: "text",
            label: "Folio solicitud",
          },
        },
        {
          input: {
            cols: 3,
            name: "fecha_solicitud",
            type: "date",
            label: "Fecha solicitud",
          },
        },
        {
          select: {
            cols: 3,
            name: "tipo_importacion",
            type: "text",
            label: "Tipo importación",
            render: (me) => {
              me.innerHTML = `<option value="">Seleccione</option>`;
              this.state.cat_tipo_importacion.forEach((ti) => {
                me.innerHTML += `<option value="${ti.id}">${ti.descripcion}</option>`;
              });
            },
          },
        },
        {
          select: {
            cols: 3,
            name: "estatus_tramite",
            type: "text",
            label: "Estado",
            render: (me) => {
              me.innerHTML = `<option value="">Seleccione</option>`;
              this.state.cat_estatus_tramite_ce
                .filter((item) =>
                  ["4", "5", "9", "7", "16", "18"].includes(item.id)
                )
                .forEach((t) => {
                  me.innerHTML += `<option value="${t.id}">${t.descripcion}</option>`;
                });
            },
          },
        },

        {
          input: {
            cols: 4,
            name: "establecimiento_importador",
            type: "text",
            label: "Establecimiento importador",
          },
        },

        {
          input: {
            cols: 4,
            name: "establecimiento_fabricante",
            type: "text",
            label: "Establecimiento fabricante",
          },
        },

        {
          input: {
            cols: 2,
            name: "fecha_verificacion",
            type: "date",
            label: "Fecha verificación",
          },
        },
        {
          button: {
            cols: 2,
            name: "buscamov",
            label: "",
            text: "Buscar",
            class: "form-control btn-warning",
            icon: "fas fa-search",
            click: (e) => {
              this.setState({ buscarCasosEspeciales: buscadorCE.data() });
              this.setCasosEspecialesPage(1);
            },
          },
        },
        // {
        //   select: {
        //     cols: 2,
        //     name: "solicitud",
        //     type: "text",
        //     label: "Trámite",
        //     render: (me) => {
        //       me.innerHTML = `<option value="">Seleccione</option>`;
        //       this.state.accionCombo.forEach((s) => {
        //         me.innerHTML += `<option value="${s.descripcion}">${s.descripcion}</option>`;
        //       });
        //     },
        //   },
        // },
      ],
    };

    buscadorCE = Api.form(buscadorCE);
    /** TERMINA BUSCADOR PARA CASOS ESPECIALES */

    //Termina componenDidMount
  }

  /* INICIA LOGICA  (grid y detalle) */

  search = [];

  handleImportacionAdicionalDataChange(e) {
    let targetName = e.target.name,
      targetValue = e.target.value,
      importacion = { ...this.state.importacion };

    this.cleanErrorsValidation(targetName);

    switch (targetName) {
      case "importacion_texto":
        importacion.importacion_texto = targetValue.toUpperCase();
        break;
      case "fines_texto":
        importacion.fines_texto = targetValue.toUpperCase();
        break;

      default:
        break;
    }

    this.setState({ importacion: importacion });
  }

  setCasosEspecialesPage(page) {
    this.setState({ workingGridCE: true });
    let search = this.state.buscarCasosEspeciales;
    let src = "";
    for (let param in search) {
      if (search[param] !== "") {
        src += "&" + param + "=" + search[param];
      }
    }
    //caso en que llegue object en el argumento de page
    if (typeof page === "object") {
      page = page.target.value;
    }

    Api.fetch(
      "app/getSolicitudesDISAANCasosEspeciales?page=" + page + src
    ).then((ce) => {
      this.setState({
        casos_especiales: ce.data,
        paginas_ce: ce.last_page,
        registros_ce: ce.total,
        paginaActual_ce: ce.current_page,
        workingGridCE: false,
      });
    });
  }

  handleSingleErrorForm(error, msg) {
    document.getElementById(error + "-error").style.display = "block";
    document.getElementById(error + "-error").innerText = msg;
    document.getElementById(error).classList.add("is-invalid");
  }

  // fn para limpar errores cuando cambie el estado del input que los tenga
  cleanErrorsValidation(elemento) {
    let divError = document.getElementById(elemento + "-error"),
      classInvalid = document.getElementById(elemento);

    if (divError && classInvalid) {
      divError.style.display = "none";
      divError.innerText = "";
      classInvalid.classList.remove("is-invalid");
    }
  }

  // funcion para cambiar el estatus de documento de caso especial
  handleCasoEspecialDocumentoEstatusChange(e) {
    e.stopPropagation();
    e.preventDefault();

    let rcedID = e.target.id,
      estatus = e.target.dataset.estatus,
      title = "¿Seguro que desea aceptar este documento?",
      btnConfirm = "Aceptar";

    if (estatus === "0") {
      title = "¿Seguro que desea rechazar este documento?";
      btnConfirm = "Rechazar";
    }

    Swal.fire({
      icon: "question",
      title: title,
      // input: "textarea",
      showCancelButton: true,
      confirmButtonText: btnConfirm,
      showLoaderOnConfirm: true,
      cancelButtonText: "Regresar",
      reverseButtons: true,
      cancelButtonColor: "Red",
      confirmButtonColor: "#4CD964",	
      // preConfirm: (razon) => {
      //   if (razon !== "") {
      //     razonText = razon;
      //     return true;
      //   } else {
      //     Swal.showValidationMessage("Debe ingresar una razón");
      //   }
      // },
      // allowOutsideClick: () => !Swal.isLoading(),
    }).then((result) => {
      if (result.isConfirmed) {
        Api.loading(true);
        Api.fetch(
          "app/setCasoEspecialDocumentoEstatus",
          {
            id: rcedID,
            estatus,
          },
          "POST"
        ).then((res) => {
          Api.loading(false);
          let caso_especial = {
            ...this.state.caso_especial,
          };

          caso_especial.documentacion = res.caso_especial.documentacion;
          caso_especial.todosDocsAprobados = caso_especial.documentacion.every(
            (d) => d.aprobado === "1"
          );

          this.setState({
            caso_especial: caso_especial,
            solicitud_ce: res.solicitud,
          });
        });
      }
    });
  }

  handleCasoEspecialEstatus(e) {
    let estatus = e.target.value,
      id = e.target.dataset.caso_especial_id,
      title = "¿Aceptar solicitud?",
      text = "Ingrese observaciones si existen",
      btnConfirm = "Aceptar",
      observacion = "",
      importacion = { ...this.state.importacion };

    if (estatus === "4") {
      title = "Descripción del rechazo";
      btnConfirm = "Continuar";
      text = "";
      this.cleanErrorsValidation("importaction_texto");
      this.cleanErrorsValidation("fines_texto");
    }

    if (!importacion.importacion_texto && estatus === "5") {
      this.handleSingleErrorForm(
        "importacion_texto",
        "Ingrese texto de importación."
      );
    }

    if (!importacion.fines_texto && estatus === "5") {
      this.handleSingleErrorForm(
        "fines_texto",
        "Ingrese motivo de importación."
      );
    }

    if (
      (importacion.importacion_texto &&
        importacion.fines_texto &&
        estatus === "5") ||
      estatus === "4"
    ) {
      Swal.fire({
        icon: "warning",
        title: title,
        input: "textarea",
        text: text,
        
        cancelButtonColor: "Red",
        confirmButtonColor: "#4CD964",
        showCancelButton: true,
        confirmButtonText: btnConfirm,
        showLoaderOnConfirm: true,
        cancelButtonText: "Regresar",
        reverseButtons: true,
        preConfirm: (razon) => {
          if (estatus === "4" && razon === "") {
            Swal.showValidationMessage("Debe ingresar una razón");
          } else {
            observacion = razon;
            return true;
          }
        },
        allowOutsideClick: () => !Swal.isLoading(),
      }).then((result) => {
        if (result.isConfirmed) {
          Api.loading(true);
          Api.fetch(
            "app/setCasoEspecialEstatus",
            {
              id,
              estatus,
              observacion,
              importacion,
            },
            "PUT"
          ).then((res) => {
            Api.loading(false);
            Swal.fire({
              title: res.message.title,
              text: res.message.text,
              icon: res.message.icon,
            });

            // No necesitamos refrescar, solo invocar la pagina actual del grid de casos especiales
            this.setCasosEspecialesPage(this.state.paginaActual);
            // Luego cerramos el modal
            this.setState({ openModalCasoEspecial: false });
          });
        }
      });
    }
  }

  // Funcion para mostrar las vistas previas en grande y/o forzar la descarga
  handlePrevia(e) {
    let doc = e.target.getAttribute("data-file");
    this.setState({ previa: true, previa_url: doc });
  }

  //Funcion auxiliar para cambiar de pagina en el grid de casos especiales
  handleCasosEspecialesPage(e) {
    this.setCasosEspecialesPage(e.target.value);
  }

  handleOpenCasoEspecial(e) {
    Api.loading(true);

    let detalleCasoEspecialId = e.target.id;

    Api.fetch(
      "app/getInfoCasoEspecial?detalle_caso_especial_id=" +
        detalleCasoEspecialId
    ).then((ce) => {
      ce.caso_especial.todosDocsAprobados =
        ce.caso_especial.documentacion.every((d) => d.aprobado === "1");

      this.setState({
        caso_especial: ce.caso_especial,
        solicitud_ce: ce.solicitud,
        working: false,
        openModalCasoEspecial: true,
        importacion: {
          importacion_texto: "",
          fines_texto: "",
        },
      });

      Api.loading(false);
    });
  }

  closeModalCasoEspecial() {
    this.setState({ openModalCasoEspecial: false });
  }

  render() {
    return (
      <div className="row">
        <div className="col-xl-12">
          <Nav tabs={true}>
            {/* casos especiales */}
            <NavItem>
              <NavLink
                className={classnames({
                  active: this.state.activeTab === "1",
                })}
                onClick={() => {
                  this.toggleTab("10");
                }}
              >
                <span className="d-sm-none">
                  CASOS ESPECIALES
                  <span className="label label-success m-l-5 t-minus-1">
                    {this.state.registros_ce}
                  </span>
                </span>
                <span className="d-sm-block d-none">
                  CASOS ESPECIALES
                  <span className="label label-success m-l-5 t-minus-1">
                    {this.state.registros_ce}
                  </span>
                </span>
              </NavLink>
            </NavItem>
          </Nav>
          <TabContent activeTab={this.state.activeTab}>
            <TabPane tabId="1">
              <div className="table-responsive">
                <fieldset>
                  <div id="buscadorCE"></div>
                </fieldset>
                <table className="table table-striped m-b-0 table-hover">
                  <thead>
                    <tr>
                      <th className="text-center">Folio solicitud</th>
                      <th className="text-center">Fecha solicitud</th>
                      <th className="text-center">Tipo importación</th>
                      <th className="text-center">
                        Establecimiento importador
                      </th>
                      <th className="text-center">
                        Establecimiento fabricante
                      </th>
                      <th className="text-center">Estado</th>
                      <th className="text-center">Fecha verificación</th>
                      <th className="text-center">Acción</th>
                    </tr>
                  </thead>
                  <tbody className={this.state.workingGridCE ? "hide" : ""}>
                    {this.state.casos_especiales.length > 0 ? (
                      this.state.casos_especiales.map((ce, index) => (
                        <tr
                          key={index}
                          // className={
                          //   ce.dias > 15 && ce.estatus === "En espera"
                          //     ? "alerta"
                          //     : ""
                          // }
                        >
                          <td className="text-center">{ce.folio_solicitud}</td>

                          <td className="text-center">
                            {ce.fecha_solicitud_fmt}
                          </td>

                          <td align="center">{ce.tipo_importacion_nombre}</td>
                          <td align="center">{ce.importador_razon_social}</td>
                          <td align="center">{ce.fabricante_razon_social}</td>
                          <td className="text-center">{ce.estado_tramite}</td>
                          <td className="text-center">
                            {ce.fecha_aprueba_sinaip_fmt}
                          </td>

                          <td className="text-center">
                            {["4", "5", "18"].includes(
                              ce.estatus_tramite_id
                            ) ? (
                              <button
                                onClick={this.handleOpenCasoEspecial}
                                id={ce.detalle_casos_especiales_id}
                                className="btn bg-gradient-blue"
                              >
                                <i
                                  id={ce.detalle_casos_especiales_id}
                                  className="fas fa-folder-open"
                                ></i>
                              </button>
                            ) : null}
                          </td>
                        </tr>
                      ))
                    ) : (
                      <tr key="1">
                        <td className="text-center" colSpan="9">
                          No hay datos
                        </td>
                      </tr>
                    )}
                  </tbody>
                </table>
                <div className={this.state.workingGridCE ? "m-10" : "hide"}>
                  <div className="progress-bar bg-orange progress-bar-striped progress-bar-animated">
                    CARGANDO INFORMACIÓN
                  </div>
                </div>
                <hr />
                <div className="d-flex align-items-center justify-content-center">
                  <ul className="pagination mb-0">
                    <li className="page-item">
                      <button
                        onClick={() => {
                          this.setCasosEspecialesPage(1);
                        }}
                        className="page-link"
                      >
                        <i className="fa fa-angle-double-left"></i>
                      </button>
                    </li>
                    <li className="page-item">
                      <button
                        onClick={() => {
                          if (this.state.paginaActual_ce - 1 > 0) {
                            this.setCasosEspecialesPage(
                              this.state.paginaActual_ce - 1
                            );
                          }
                        }}
                        className="page-link"
                      >
                        <i className="fa fa-angle-left"></i>
                      </button>
                    </li>
                    <li className="page-item d-flex align-items-center px-2">
                      <div>
                        Página
                        <strong>
                          {" "}
                          {this.state.paginaActual_ce} de{" "}
                          {this.state.paginas_ce}
                        </strong>
                      </div>
                    </li>
                    <li className="page-item">
                      <button
                        onClick={() => {
                          if (
                            this.state.paginas_ce >=
                            this.state.paginaActual_ce + 1
                          ) {
                            this.setCasosEspecialesPage(
                              this.state.paginaActual_ce + 1
                            );
                          }
                        }}
                        className="page-link"
                      >
                        <i className="fa fa-angle-right"></i>
                      </button>
                    </li>
                    <li className="page-item">
                      <button
                        onClick={() => {
                          this.setCasosEspecialesPage(this.state.paginas_ce);
                        }}
                        className="page-link"
                      >
                        <i className="fa fa-angle-double-right"></i>
                      </button>
                    </li>
                  </ul>
                  <div className="ml-3 mr-1">Página:</div>
                  <div className="width-50 mx-2">
                    <input
                      className="form-control"
                      onChange={this.handleCasosEspecialesPage}
                      type="number"
                      min="1"
                      max={this.state.paginas_ce}
                      value={this.state.paginaActual_ce}
                    />
                  </div>
                  <div></div>
                </div>
              </div>
            </TabPane>
          </TabContent>
        </div>

        <div className={this.state.previa ? "previa" : "hide"}>
          <iframe
            title="Vista previa"
            className="rounded"
            src={this.state.previa_url}
          ></iframe>
          <center>
            <div className="btn-group">
              <button
                onClick={() => {
                  this.setState({ previa: false, previa_url: "" });
                }}
                className="btn btn-danger"
              >
                Regresar
              </button>
              <a
                className="btn btn-primary"
                href={this.state.previa_url + "&download=1"}
                download="download"
              >
                Descargar
              </a>
            </div>
          </center>
        </div>

        {/* Casos especiales */}
        <Modal
          isOpen={this.state.openModalCasoEspecial}
          tabIndex="-1"
          style={{
            maxWidth: "100%",
            width: "85%",
          }}
        >
          <ModalHeader
            toggle={() => {
              this.closeModalCasoEspecial();
              //this.limpiarCampos(2);
            }}
            className="text-center"
          >
            Solicitud: {this.state.solicitud_ce.folio_solicitud}
          </ModalHeader>
          <ModalBody>
            <div className={this.state.workingGridMP ? "" : "hide"}>
              <div className="progress-bar bg-orange progress-bar-striped progress-bar-animated">
                CARGANDO INFORMACIÓN
              </div>
            </div>
            <ModalSolicitudDISAANCasoEspecial
              key={this.state.solicitud_mov.solicitud_id}
              handlePrevia={this.handlePrevia}
              handleCasoEspecialDocumentoEstatusChange={
                this.handleCasoEspecialDocumentoEstatusChange
              }
              setCasosEspecialesPage={this.setCasosEspecialesPage}
              closeModalCasoEspecial={this.closeModalCasoEspecial}
              handleCasosEspecialesPage={this.handleCasosEspecialesPage}
              handleCasoEspecialEstatus={this.handleCasoEspecialEstatus}
              handleImportacionAdicionalDataChange={
                this.handleImportacionAdicionalDataChange
              }
              state={this.state}
            />
          </ModalBody>
        </Modal>
        {/* fin */}
      </div>
    );
  }
}
let App = (props) => {
  const auth = useAuth();
  const history = useHistory();
  return <Applications auth={auth} history={history} {...props} />;
};
export default App;
